module.exports = __webpack_public_path__ + "static/media/on-gold.92843108.png";